import { acknowledgeAlert, isAlertAcknowledged } from './alert_banner_cookie';

function initAlertBanner(alert) {
  alert.classList.remove('hidden');
  const alertExit = alert.querySelector('.wework-page-alert-exit');
  alertExit.addEventListener('click', () => {
    acknowledgeAlert(alert.id);
    alert.classList.add('hidden');
    alertExit.removeEventListener();
  });
}

export function displayBanner() {
  const alertsList = document.querySelectorAll('.wework-page-alert');
  for (let i = 0; i < alertsList.length; i++) {
    const currentAlert = alertsList[i];
    if (!isAlertAcknowledged(currentAlert.id)) {
      initAlertBanner(currentAlert);
      break;
    }
  }
}
